<template>
    <div class="user-import-summary">
        <section class="form-section">
            <div class="form-section-heading">
                {{ trans('users.headline.summary') }}
                <span class="user-import-configuration">
                    <img class="user-import-configuration__icon" @click="openConfigurationModal" src="/images/icons/configuration.svg" />
                </span>
            </div>

            <user-import-summary-text
                :users-to-be-imported="usersToBeImported"
                :client="client"
                :assigned-courses="assignedCourses"
                :assigned-usergroups="assignedUsergroups"
            ></user-import-summary-text>
        </section>

        <section class="form-section" v-show="countUsersWithoutEmail">
            <div class="form-section-heading">{{ trans('users.headline.check') }}</div>

            <alert class="h:margin-bottom-8" type="warning">
                <div class="user-import-check">
                    <div class="user-import-check__text">
                        {{ trans('users.note.user_import_check', {count: countUsersWithoutEmail}) }}
                    </div>

                    <div class="user-import-check__input">
                        <div class="form-row">
                            <div class="form-row__col">
                                <form-input
                                    name="shared_email"
                                    v-model="sharedEmail"
                                    @input="mapSharedEmail()"
                                >
                                    {{ trans('users.label.shared_email') }}
                                </form-input>
                            </div>
                        </div>
                    </div>
                </div>
            </alert>
        </section>

        <section class="form-section">
            <div class="form-section-heading">{{ trans('users.headline.user_list') }}</div>

            <extendable-card-list
                v-model="usersToBeImported"
                v-slot="slot"
                :cards="usersToBeImported"
                :errors="errors"
                data-can-be-edited
                data-can-be-deleted
            >
                <user-import-summary-card :user="slot.data" :index="slot.index" :errors="slot.errors" v-model="usersToBeImported"></user-import-summary-card>
            </extendable-card-list>
        </section>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';
import UserImportSummaryConfigurationModal from './UserImportSummaryConfigurationModal';

export default {
    props: {
        usersToBeImported: Array,
        client: Object,
        assignedCourses: Array,
        assignedUsergroups: Array,
    },

    data() {
        return {
            sharedEmail: '',
            errors: {},
            countUsersWithoutEmail: 0,
            config: {},
        };
    },

    watch: {
        usersToBeImported: function() {
            this.getCountUsersWithoutEmail();
        }
    },
    computed: {
        // pass a simpler object to the backend
        assignedCoursesToSubmit() {
            return this.assignedCourses.map((assignedCourse) => {
                return {
                    client_id: assignedCourse.client.id,
                    course_id: assignedCourse.course.id,
                    start_date: assignedCourse.start_date,
                    end_date: assignedCourse.end_date
                }
            });
        },
        // pass a simpler object to the backend
        assignedUsergroupsToSubmit() {
            return this.assignedUsergroups.map((assignedUserGroup) => {
                return {
                    user_group_id: assignedUserGroup.user_group.id,
                    client_id: assignedUserGroup.client ? assignedUserGroup.client.id : null,
                    start_date: assignedUserGroup.start_date || null,
                    end_date: assignedUserGroup.end_date || null
                }
            });
        }
    },

    methods: {
        openConfigurationModal() {
            this.$modal.show(UserImportSummaryConfigurationModal, {
                'old-resend-credentials': this.config.resend_credentials,
                'old-delete-not-imported-users': this.config.delete_not_imported_users,
            });
        },

        submitForm() {
            axios
                .post(this.route('tenantapi.user-import.store'), {
                    'users-to-be-imported': this.usersToBeImported,
                    'client_id': this.client.id,
                    'courses': this.assignedCoursesToSubmit,
                    'user_groups': this.assignedUsergroupsToSubmit,
                    'config': this.config,
                })
                .then(this.handleResponse)
                .catch(({response}) => {
                    this.errors = response.data.errors;
                });
        },

        handleResponse(response) {
            if (response.status == 200) {
                location.href = this.route('tenant.user-import.confirmation');
            }
        },

        mapSharedEmail() {
            EventBus.$emit('setSharedEmail', this.sharedEmail);
        },

        getCountUsersWithoutEmail() {
            this.countUsersWithoutEmail = this.usersToBeImported.filter(user => {
                return !user.email;
            }).length;
        },
    },

    mounted() {
        EventBus.$on('submitForm', () => this.submitForm());
        EventBus.$on('update-config', (config) => this.config = config);
    }
};
</script>
